export default "__VITE_ASSET__BhZI5EaB__"